import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//types
import {
	IAttentionList,
	IOrganizationDashboardAuctionItemsResponse,
	IOrganizationDashboardCheckedInResponse,
	IOrganizationDashboardSpecialMealsResponse,
	IOrganizationDashboardStatistics,
	IOrganizationDashboardTablesSoldResponse,
	IOrganizationDashboardUnknownGuestsResponse,
	IRequestWithPagination,
} from '../../utils/types';
//services
import {OrganizationDashboardService} from '@/utils/services';
//helpers
import {getErrorResponse} from '@/utils/helpers';

export const getDashboardStatistics = createAsyncThunk(
	ACTION_TYPE.DASHBOARD_STATISTICS,
	async (reqBody: number, {rejectWithValue}) => {
		try {
			const dashboardResponse: AxiosResponse<IOrganizationDashboardStatistics> =
				await OrganizationDashboardService.getDashboardStatistics(reqBody);

			return dashboardResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getDashboardTablesSold = createAsyncThunk(
	ACTION_TYPE.DASHBOARD_TABLES_SOLD,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const dashboardResponse: AxiosResponse<IOrganizationDashboardTablesSoldResponse> =
				await OrganizationDashboardService.getDashboardTablesSold(reqBody);

			return dashboardResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getDashboardUnknownGuests = createAsyncThunk(
	ACTION_TYPE.DASHBOARD_UNKNOWN_GUESTS,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const dashboardResponse: AxiosResponse<IOrganizationDashboardUnknownGuestsResponse> =
				await OrganizationDashboardService.getDashboardUnknownGuests(reqBody);

			return dashboardResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getDashboardAuctionItems = createAsyncThunk(
	ACTION_TYPE.DASHBOARD_AUCTION_ITEMS,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const dashboardResponse: AxiosResponse<IOrganizationDashboardAuctionItemsResponse> =
				await OrganizationDashboardService.getDashboardAuctionItems(reqBody);

			return dashboardResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getDashboardCheckedIn = createAsyncThunk(
	ACTION_TYPE.DASHBOARD_CHECKED_IN,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const dashboardResponse: AxiosResponse<IOrganizationDashboardCheckedInResponse> =
				await OrganizationDashboardService.getDashboardCheckedIn(reqBody);

			return dashboardResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getDashboardSpecialMeals = createAsyncThunk(
	ACTION_TYPE.DASHBOARD_SPECIAL_MEALS,
	async (reqBody: IRequestWithPagination, {rejectWithValue}) => {
		try {
			const dashboardResponse: AxiosResponse<IOrganizationDashboardSpecialMealsResponse> =
				await OrganizationDashboardService.getDashboardSpecialMeals(reqBody);

			return dashboardResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getDashboardAttentionList = createAsyncThunk(
	ACTION_TYPE.DASHBOARD_ATTENTION_LIST,
	async (reqBody: {organizationId: number; eventId: number}, {rejectWithValue}) => {
		try {
			const dashboardResponse: AxiosResponse<IAttentionList> =
				await OrganizationDashboardService.getDashboardAttentionList(reqBody);

			return dashboardResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
